import { Box, Divider, Typography } from '@mui/material'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Derivery } from 'pages/Derivery/Derivery'
import { Finish } from 'pages/Finish/Finish'
import { Next } from 'pages/Next/Next'
import { Uploading } from 'components/Uploading/Uploading'
import { ErrorDialog } from 'components/ErrorDialog/ErrorDialog'
import { ProgressIndicator } from 'components/ProgressIndicator/ProgressIndicator'

const App = () => {
  return (
    <BrowserRouter>
      <Box sx={{ position: 'sticky', backgroundColor: 'white', top: 0, zIndex: 2 }}>
        <Typography variant="h6" fontWeight="bold" sx={{ p: 2 }}>
          宅配の窓口
        </Typography>
        <Divider />
      </Box>
      <Routes>
        <Route path="/" element={<Derivery />} />
        <Route path="/next" element={<Next />} />
        <Route path="/finish" element={<Finish />} />
      </Routes>
      <Uploading />
      <ErrorDialog />
      <ProgressIndicator />
    </BrowserRouter>
  )
}

export default App
